import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from "react";
import cx from "classnames";
import { Button } from "../Button";
import styles from "./Modal.less";
export var Modal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onEsc", function (evt) {
      if (evt.key === "Escape" || evt.keyCode == 27) {
        _this.props.onClose();
      }
    });

    if (!props.onClose) {
      throw new Error("Modal component is missing required `onClose` property");
    }

    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("keypress", this.onEsc);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("keypress", this.onEsc);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("section", {
        className: cx(styles.ModalWrap, this.props.type === "local" ? styles.ModalLocal : styles.ModalGlobal)
      }, React.createElement("article", {
        className: cx(styles.Modal, this.props.className)
      }, React.createElement(Button, {
        className: styles.Close,
        onClick: this.props.onClose
      }, React.createElement("i", {
        className: "fa fa-times",
        "aria-hidden": "true"
      })), this.props.children));
    }
  }]);

  return Modal;
}(React.Component);
export function ModalHeader(props) {
  return React.createElement("header", {
    className: cx(styles.ModalHeader, props.className)
  }, props.children);
}
export function ModalContent(props) {
  return React.createElement("main", _extends({}, props, {
    className: cx(styles.ModalContent, props.className)
  }), props.children);
}
export function ModalFooter(props) {
  return React.createElement("footer", {
    className: cx(styles.ModalFooter, props.className)
  }, props.children);
}